import { render } from "./AppFooter.vue?vue&type=template&id=3e16a1fe&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=3e16a1fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e16a1fe"]])

export default __exports__